module.exports = __webpack_public_path__ + "img/9.8a148bdd.jpg";